var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("CargoMsg.Cargo_SelectTheApprovalPosition"),
        "before-close": _vm.cancel,
        width: "1160px",
        "append-to-body": ""
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ],
          staticStyle: { display: "flex", margin: "10px" }
        },
        [
          _c(
            "span",
            { staticStyle: { "align-self": "center", "margin-right": "5px" } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")) + ": ")]
          ),
          _c("el-input", {
            staticStyle: { width: "300px" },
            attrs: { placeholder: _vm.$t("SeaExport.PleaseInputAKeyword") },
            model: {
              value: _vm.searchValue,
              callback: function($$v) {
                _vm.searchValue = $$v
              },
              expression: "searchValue"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "grid" },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", "min-height": "400px" },
            attrs: {
              "show-side-bar": false,
              "grid-options": _vm.officeDeptTree.gridOptions,
              "column-defs": _vm.officeDeptTree.columnDefs,
              "row-data": _vm.filterData
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c("div", { staticStyle: { display: "flex", "text-align": "left" } }, [
          _c("span", { staticClass: "blue" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CurrentSelection")) + ":")
          ]),
          _c(
            "div",
            {
              staticStyle: {
                flex: "1",
                "overflow-y": "auto",
                "text-align": "left",
                "word-break": "break-word",
                "margin-left": "5px"
              }
            },
            [_vm._v(" " + _vm._s(_vm.displayName) + " ")]
          )
        ]),
        _c(
          "div",
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onSave } },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
            ),
            _c("el-button", { on: { click: _vm.onReset } }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Reset")))
            ]),
            _c("el-button", { on: { click: _vm.cancel } }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))
            ])
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }